// ============================================================
// Not Found Page (404)
// ============================================================

import { Box, Typography, Button } from '@mui/material';
import { FileQuestion, ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { tokens } from '@/theme/tokens';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: tokens.radius.full,
          backgroundColor: `${tokens.colors.primary.main}10`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <FileQuestion size={40} color={tokens.colors.primary.main} />
      </Box>
      <Typography variant="h3" fontWeight={700} sx={{ mb: 1 }}>
        404
      </Typography>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 1 }}>
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: 400 }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => navigate(-1)}
          sx={{ borderRadius: tokens.radius.full, px: 3, textTransform: 'none', fontWeight: 600 }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/dashboard')}
          sx={{ borderRadius: tokens.radius.full, px: 3, textTransform: 'none', fontWeight: 600 }}
        >
          Go Home
        </Button>
      </Box>
    </Box>
  );
}
